import request from '@/utils/request';
import type { FetchActivityResp } from '@/pages/Activity/activity-history.data';

export async function fetchActivities(params?: any): Promise<FetchActivityResp> {
  return request.get('/cms/activity-histories', {
    params,
  });
}
